import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionPhotoLogUpdatePayload,
	IActionPhotoLogUpdatePayloadDone,
	IActionPhotoLogUpdatePayloadError,
} from './types';

export const photoLogUpdate = actionCreatorAsync<
	IActionPhotoLogUpdatePayload,
	IActionPhotoLogUpdatePayloadDone,
	IActionPhotoLogUpdatePayloadError
>(
	'photoLogUpdate',
	async (params) => {
		const { id, photoLog } = params;
		const { data } = await Api.photoLog.update({
			params: { id },
			body: photoLog,
		});

		return data;
	},
);
